//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Stap3',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    formData: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    submit(data) {
      this.$emit('submit', data);
    },
  },
};
